import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DateConfig } from '../../../entities/date-config';
import {CommonService} from '../../../services/common/common.service';
import {DatePipe} from '@angular/common';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
// import * as differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

@Component({
  selector: 'app-s-date',
  templateUrl: './s-date.component.html',
  styleUrls: ['./s-date.component.less'],
  providers: [DatePipe]
})
export class SDateComponent implements OnInit, OnChanges {

  @Input() dateObj: DateConfig;
  @Output() yearChange: EventEmitter<any> =  new EventEmitter();
  @Output() monthChange: EventEmitter<any> =  new EventEmitter();
  @Output() weekChange: EventEmitter<any> =  new EventEmitter();
  @Output() dateChange: EventEmitter<any> =  new EventEmitter();
  @Output() rangeDateChange: EventEmitter<any> =  new EventEmitter();
  /** 日期范围选择结果 */
  rangeDate: any = {
    startDate: null,
    endDate: null
  };
  s: Date;
  today = new Date();

  all = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) === 100000;
  }
  /** 大于等于当前年份/月份/周可选择，包含当前年份/月份/周 */
  more = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < -1;
  }
  moreDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < 0;
  }

   /** 小于等于当前年份/月份/周可选择，包含当前年份/月份/周 */
  less = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > 0;
  }

  /** 大于当前年份/月份/周可选择，不包含当前年份/月份/周 */
  removecurentMore  = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < 1;
  }

  /** 小当前年份/月份/周可选择，不包含当前年份/月份/周 */
  removecurentLess = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > -1;
  }

  /** 日期范围选择：开始时间可选择范围 */
  startDate = (current: Date): boolean => {
    if (!current) {
      return false;
    }
    return differenceInCalendarDays(current, this.today) < 0;
  }
  /** 日期范围选择：开始时间可选择范围(当天不可选择) */
  startRemoveCurrentDate = (current: Date): boolean => {
    if (!current) {
      return false;
    }
    return differenceInCalendarDays(current, this.today) < 1;
  }
  /** 日期范围选择：结束时间可选择范围 */
  disableEndDate = (current: Date): boolean => {
    if (!current) {
      return false;
    }
    return current.getTime() < this.rangeDate.startDate.getTime();
  }
  /** 日期范围选择：开始时间可选择范围 */
  disableStart = (current: Date): boolean => {
    if (!current) {
      return false;
    }
    return current.getTime() > (this.rangeDate.end || new Date()).getTime();
  }
  // /**日期范围选择：结束时间可选择范围(当天不可选择) */
  // endRemoveCurrentDate  = (current: Date): boolean => {
  //   if (!current || this.rangeDate.startDate) {
  //     return false;
  //   }
  //   return differenceInCalendarDays(current, this.today) < 1;
  // }

  constructor(
    private commonService: CommonService,
    private datepipe: DatePipe
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
  }


  ngOnInit(): void {
    this.initDateObj();
  }

  onYearChange(e: Date, format: any) {
    if (e) {
      this.yearChange.emit(this.datepipe.transform(e, format));
    } else {
      this.yearChange.emit(null);
    }
  }

  onMonthChange(e: Date, format: any) {
    if (e) {
      this.monthChange.emit(this.datepipe.transform(e, format));
    } else {
      this.monthChange.emit(null);
    }
  }

  onWeekChange(e: Date, format: any) {
    if (e) {
      this.weekChange.emit(this.datepipe.transform(e, format));
    } else {
      this.weekChange.emit(null);
    }
  }

  onDateChange(e: Date, dateObj: DateConfig) {
    this.dateChange.emit(this.isShowTimeFormat(e, dateObj));
  }

  rangeChange([start, end], dateObj) {
    const obj = {
      startDate: this.isShowTimeFormat(start, dateObj),
      endDate: this.isShowTimeFormat(end, dateObj)
    };
    this.rangeDateChange.emit(obj);
  }

  onRangeDateChange(e: Date, dateObj: DateConfig, type: string) {

    if (e) {
      if (type === 'start') {
        this.rangeDate.startDate = e;
        // this.rangeDate.endDate = null;
        // dateObj.endValue = null;
        dateObj.endDisabled = false;
      } else {
        this.rangeDate.endDate = e;
      }
    } else {
      if (type === 'start') {
        dateObj.startValue = null;
        dateObj.endValue = null;
        this.rangeDate.startDate = null;
        this.rangeDate.endValue = null;
        dateObj.endDisabled = true;
      } else {
        dateObj.endValue = null;
        this.rangeDate.endValue = null;
        this.rangeDate.endDate = null;
      }
    }
    const obj = {
      startDate: this.isShowTimeFormat(this.rangeDate.startDate, dateObj),
      endDate: this.isShowTimeFormat(this.rangeDate.endDate, dateObj)
    };
    this.rangeDateChange.emit(obj);
  }

  isShowTimeFormat(e: Date, dateObj: DateConfig) {
    let result: any;
    let format: any;
    if (e) {
      if (!dateObj.showTime) {
        if (!dateObj.format) {
          format = 'yyyy-MM-dd';
        } else {
          format = dateObj.format;
        }
      } else {
        if (!dateObj.format) {
          format = 'yyyy-MM-dd HH:mm:ss';
        } else {
          format = dateObj.format;
        }
      }
      result = this.datepipe.transform(e, format);
    } else {
      result = null;
    }
    return result;
  }

  initDateObj() {
    const dateObj = this.dateObj;
    dateObj.allowClear = this.commonService.isNull(dateObj.allowClear) ? dateObj.allowClear : true;
    dateObj.showTime = this.commonService.isNull(dateObj.showTime) ? dateObj.showTime : false;
    dateObj.disabled = this.commonService.isNull(dateObj.disabled) ? dateObj.disabled : false;
    dateObj.showToday = this.commonService.isNull(dateObj.showToday) ? dateObj.showToday : false;
    dateObj.isRemoveCurrent = this.commonService.isNull(dateObj.isRemoveCurrent) ? dateObj.isRemoveCurrent : false;
    dateObj.isMoreCurrent = this.commonService.isNull(dateObj.isMoreCurrent) ? dateObj.isMoreCurrent : false;
    dateObj.isLessCurrent = this.commonService.isNull(dateObj.isLessCurrent) ? dateObj.isLessCurrent : false;
    if (dateObj.type === 'rangDate') {
      dateObj.endDisabled = true;
    }
    this.dateObj = dateObj;
  }
}
